import React from "react";
import Hero from "../components/Hero";
import { useLanguage } from "../context/LanguageContext";
import "../styles/Legales.css";

const translations = {
  ES: {
    title: "Legales",
    legalNotice:
      "AVISO LEGAL, POLÍTICA DE PRIVACIDAD, POLÍTICA DE COOKIES Y TÉRMINOS Y CONDICIONES",
    legalNoticeContent: [
      {
        sectionTitle: "1. AVISO LEGAL",
        content: [
          "De conformidad con la Ley 34/2002 de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa a los usuarios de la web www.gcemporda.com lo siguiente:",
          [
            { label: "Titular:", value: "Mauro Zacarias" },
            { label: "Domicilio:", value: "Sitges 11" },
            { label: "NIF/CIF:", value: "Z1907841L" },
            {
              label: "Correo electrónico de contacto:",
              value: "info@gcemporda.com",
            },
          ],
          "El acceso a esta web implica la aceptación de los términos y condiciones de uso aquí expuestos.",
        ],
      },
      {
        sectionTitle: "2. POLÍTICA DE PRIVACIDAD",
        content: [
          "De acuerdo con el Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica de Protección de Datos y Garantía de Derechos Digitales (LOPDGDD), garantizamos la seguridad y confidencialidad de los datos personales que nos faciliten los usuarios.",
          "Finalidad del tratamiento:",
          [
            "Gestionar el acceso y la navegación en la web.",
            "Enviar comunicaciones comerciales e informativas si el usuario lo ha autorizado.",
            "Gestionar solicitudes de contacto.",
          ],
          "Legitimación: Consentimiento del usuario.",
          "Conservación de los datos: Los datos se conservarán mientras sean necesarios para la finalidad con la que fueron recopilados o hasta que el usuario solicite su supresión.",
          "Derechos del usuario: El usuario puede ejercer sus derechos de acceso, rectificación, supresión, oposición y portabilidad escribiendo a info@gcemporda.com con el asunto 'Protección de Datos' y adjuntando una copia de su DNI.",
        ],
      },
      {
        sectionTitle: "3. POLÍTICA DE COOKIES",
        content: [
          "Utilizamos cookies para mejorar la experiencia del usuario. Al navegar en esta web, el usuario acepta su uso.",
          "¿Qué son las cookies?",
          "Son archivos pequeños que se almacenan en el dispositivo del usuario y que permiten recordar preferencias de navegación.",
          "Tipos de cookies utilizadas:",
          [
            {
              label: "Cookies técnicas:",
              value: "Necesarias para el funcionamiento de la web.",
            },
            {
              label: "Cookies de análisis:",
              value: "Permiten conocer el comportamiento de los usuarios.",
            },
            {
              label: "Cookies publicitarias:",
              value: "Gestionan la frecuencia y contenido de los anuncios.",
            },
          ],
          "El usuario puede configurar el uso de cookies desde la configuración de su navegador.",
        ],
      },
      {
        sectionTitle: "4. TÉRMINOS Y CONDICIONES",
        content: [
          "Uso de la web:",
          "El usuario se compromete a hacer un uso adecuado de los contenidos y servicios y a no emplearlos para actividades ilícitas.",
          "Propiedad intelectual:",
          "Todos los contenidos de esta web (textos, imágenes, logotipos, diseños) están protegidos por derechos de autor y no pueden ser utilizados sin autorización expresa.",
          "Limitación de responsabilidad:",
          "El titular de la web no se hace responsable del mal uso que puedan hacer los usuarios ni de posibles fallos técnicos ajenos a su control.",
          "Modificaciones:",
          "Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento.",
        ],
      },
    ],
    contactEmail:
      "Para cualquier duda o consulta, puede contactarnos en info@gcemporda.com.",
  },
  CAT: {
    title: "Legals",
    legalNotice:
      "AVÍS LEGAL, POLÍTICA DE PRIVACITAT, POLÍTICA DE COOKIES I TERMES I CONDICIONS",
    legalNoticeContent: [
      {
        sectionTitle: "1. AVÍS LEGAL",
        content: [
          "D'acord amb la Llei 34/2002 de Serveis de la Societat de la Informació i de Comerç Electrònic (LSSI-CE), s'informa als usuaris del web www.gcemporda.com del següent:",
          [
            { label: "Titular:", value: "Mauro Zacarias" },
            { label: "Domicili:", value: "Sitges 11" },
            { label: "NIF/CIF:", value: "Z1907841L" },
            {
              label: "Correu electrònic de contacte:",
              value: "info@gcemporda.com",
            },
          ],
          "L'accés a aquest web implica l'acceptació dels termes i condicions d'ús exposats aquí.",
        ],
      },
      {
        sectionTitle: "2. POLÍTICA DE PRIVACITAT",
        content: [
          "D'acord amb el Reglament General de Protecció de Dades (RGPD) i la Llei Orgànica de Protecció de Dades i Garantia dels Drets Digitals (LOPDGDD), garantim la seguretat i confidencialitat de les dades personals que ens facilitin els usuaris.",
          "Finalitat del tractament:",
          [
            "Gestionar l'accés i la navegació al web.",
            "Enviar comunicacions comercials i informatives si l'usuari ho ha autoritzat.",
            "Gestionar sol·licituds de contacte.",
          ],
          "Legitimació: Consentiment de l'usuari.",
          "Conservació de les dades: Les dades es conservaran mentre siguin necessàries per a la finalitat amb la qual van ser recopilades o fins que l'usuari sol·liciti la seva supressió.",
          "Drets de l'usuari: L'usuari pot exercir els seus drets d'accés, rectificació, supressió, oposició i portabilitat escrivint a info@gcemporda.com amb l'assumpte 'Protecció de Dades' i adjuntant una còpia del seu DNI.",
        ],
      },
      {
        sectionTitle: "3. POLÍTICA DE COOKIES",
        content: [
          "Utilitzem cookies per millorar l'experiència de l'usuari. En navegar per aquest web, l'usuari accepta el seu ús.",
          "Què són les cookies?",
          "Són fitxers petits que s'emmagatzemen al dispositiu de l'usuari i que permeten recordar preferències de navegació.",
          "Tipus de cookies utilitzades:",
          [
            {
              label: "Cookies tècniques:",
              value: "Necessàries per al funcionament del web.",
            },
            {
              label: "Cookies d'anàlisi:",
              value: "Permeten conèixer el comportament dels usuaris.",
            },
            {
              label: "Cookies publicitàries:",
              value: "Gestionen la freqüència i contingut dels anuncis.",
            },
          ],
          "L'usuari pot configurar l'ús de cookies des de la configuració del seu navegador.",
        ],
      },
      {
        sectionTitle: "4. TERMES I CONDICIONS",
        content: [
          "Ús del web:",
          "L'usuari es compromet a fer un ús adequat dels continguts i serveis i a no emprar-los per a activitats il·lícites.",
          "Propietat intel·lectual:",
          "Tots els continguts d'aquest web (textos, imatges, logotips, dissenys) estan protegits per drets d'autor i no poden ser utilitzats sense autorització expressa.",
          "Limitació de responsabilitat:",
          "El titular del web no es fa responsable del mal ús que puguin fer els usuaris ni de possibles fallades tècniques alienes al seu control.",
          "Modificacions:",
          "Ens reservem el dret de modificar aquests termes i condicions en qualsevol moment.",
        ],
      },
    ],
    contactEmail:
      "Per a qualsevol dubte o consulta, podeu contactar-nos a info@gcemporda.com.",
  },
};

const Legales = () => {
  const { language } = useLanguage();
  const { title, legalNotice, legalNoticeContent, contactEmail } =
    translations[language];

  return (
    <>
      <Hero title={title} />
      <div className="legales-container">
        <h1>{legalNotice}</h1>
        {legalNoticeContent.map((section, index) => (
          <section key={index}>
            <h2>{section.sectionTitle}</h2>
            {section.content.map((item, idx) => (
              <React.Fragment key={idx}>
                {Array.isArray(item) ? (
                  item.map((subItem, subIdx) => (
                    <p key={subIdx}>
                      {subItem.label && <strong>{subItem.label}</strong>}{" "}
                      {subItem.value}
                    </p>
                  ))
                ) : (
                  <p>{item}</p>
                )}
              </React.Fragment>
            ))}
          </section>
        ))}
        <p>{contactEmail}</p>
      </div>
    </>
  );
};

export default Legales;
